import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { BaseResponse } from 'src/app/models/base.interface';
import { Image } from 'src/app/models/shared/image/image.interface';
import { UploadImageConstant, UploadThemeCssConstant } from '../../constants/common-constant';
@Injectable({
    providedIn: 'root'
})
export class UploadService {

    constructor(
        private httpService: HttpService,
    ) { }

    uploadImage(type: string, file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read file as Data URL (Base64)

            reader.onload = () => {
                const base64String = (reader.result as string).split(',')[1]; // Extract Base64 part
                const timestamp = new Date().getTime();
                const fileExtension = file.name.split('.').pop()?.toLowerCase(); // Get file extension
                const fileName = `${file.name.split('.').slice(0, -1).join('.')}_${timestamp}.${fileExtension}`;

                // Determine the content type based on file extension
                const contentType = fileExtension === 'png' ? 'image/png'
                    : fileExtension === 'jpg' || fileExtension === 'jpeg' ? 'image/jpeg'
                        : fileExtension === 'gif' ? 'image/gif'
                            : fileExtension === 'svg' ? 'image/svg+xml'
                                : 'application/octet-stream';

                const payload = {
                    imageName: fileName,
                    imageData: base64String,
                    imageContentType: contentType
                };

                const { container, controller, action } = UploadImageConstant[type];

                this.httpService.post(container, controller, action, payload)
                    .subscribe({
                        next: (resp: BaseResponse<Image>) => {
                            if (resp && resp.code == 1) {
                                resolve(resp.data.imageUrl);
                            } else {
                                resolve('');
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });
            };

            reader.onerror = (error) => reject(error);
        });
    }

    uploadImageWithCustomFileName(type: string, file: File, customFileName: string): Promise<{ imageUrl: string, finalFileName: string }> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Read file as Base64

            reader.onload = () => {
                const base64String = (reader.result as string).split(',')[1]; // Remove prefix
                const fileExtension = file.name.split('.').pop()?.toLowerCase() || 'jpg';

                // Determine content type
                const contentType = fileExtension === 'png' ? 'image/png'
                    : fileExtension === 'jpg' || fileExtension === 'jpeg' ? 'image/jpeg'
                        : fileExtension === 'gif' ? 'image/gif'
                            : fileExtension === 'svg' ? 'image/svg+xml'
                                : 'application/octet-stream';

                const payload = {
                    imageName: customFileName,
                    imageData: base64String,
                    imageContentType: contentType
                };

                const { container, controller, action } = UploadImageConstant[type];

                this.httpService.post(container, controller, action, payload, false).subscribe({
                    next: (resp: BaseResponse<Image>) => {
                        if (resp && resp.code === 1) {
                            resolve({ imageUrl: resp.data.imageUrl, finalFileName: customFileName });
                        } else {
                            resolve({ imageUrl: '', finalFileName: customFileName });
                        }
                    },
                    error: (error) => reject(error)
                });
            };

            reader.onerror = (error) => reject(error);
        });
    }

    // If webType = Admin then merchantCode = 0
    uploadCssFile(webType: string, merchantCode: string, cssContent: string): Promise<string> {
        return new Promise((resolve, reject) => {
            {
                const payload = {
                    fileName: `theme-${webType.toLowerCase()}-${merchantCode}.css`,
                    fileData: btoa(unescape(encodeURIComponent(cssContent))),
                    fileContentType: 'text/css'
                };

                const { container, controller, action } = UploadThemeCssConstant[webType];

                this.httpService.post(container, controller, action, payload)
                    .subscribe({
                        next: (resp: BaseResponse<{ fileUrl: '' }>) => {
                            if (resp && resp.code == 1) {
                                resolve(resp.data.fileUrl);
                            } else {
                                resolve('');
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });

            }
        });
    }


    validateImageDimensions(file: File, minWidth: number, minHeight: number, maxWidth: number, maxHeight: number): Promise<boolean> {
        return new Promise((resolve) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e: any) => {
                img.src = e.target.result;
            };

            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const isValid = width >= minWidth && height >= minHeight && width <= maxWidth && height <= maxHeight;
                resolve(isValid);
            };

            reader.readAsDataURL(file);
        });
    }
}
